export default __webpack_public_path__ + "static/media/TheElements _18.904501aa.png";